@let videoId = videoIdField();
@let heading = headingField();

<div class="video" [class.text-center]="isEd()">
  <div class="row">
    <div class="offset-lg-2 col-lg-8">
      <h2 *scText="heading"></h2>
      @if (showDescriptionField() && descriptionField(); as descriptionField) {
        <p *scText="descriptionField"></p>
      }
    </div>
  </div>

  @if (videoId && videoId.value && heading && heading.value) {
    <div class="row">
      <div class="offset-lg-2 col-lg-8">
        <wl-video-player
          [videoId]="videoId.value"
          [title]="heading.value"
          ngskiphydration
        />
      </div>
    </div>
  }

  @if (isEditorActive()) {
    <div class="text-center border rounded p-2 bg-light">
      <span class="form-label fw-bold d-block">YouTube video ID</span>
      <span class="d-block text-muted" *scText="videoIdField()"
        >Enter the YouTube video ID here</span
      >
    </div>
  }
</div>
